// extracted by mini-css-extract-plugin
export var actions = "_3u-0";
export var actionsContainer = "_3u-6";
export var border = "_3u-1";
export var childFullHeight = "_3u-d";
export var collapse = "_3u-2";
export var content = "_3u-8";
export var contentChild = "_3u-c";
export var fullscreen = "_3u-a";
export var headerContainer = "_3u-3";
export var headerRow = "_3u-5";
export var hidePadding = "_3u-9";
export var noScrollX = "_3u-e";
export var noScrollY = "_3u-f";
export var optOutTopPadding = "_3u-b";
export var pagePadding = "_3u-7";
export var profile = "_3u-g";
export var profileContainer = "_3u-h";
export var profileImage = "_3u-i";
export var profileMain = "_3u-j";
export var profileSubtitle = "_3u-l";
export var profileTitle = "_3u-k";
export var tabsWrapper = "_3u-4";
export var title = "_3u-m";